import React from 'react'
import styled from 'styled-components'

// Styles
import tagBaseStyle from './TagBase'

interface IProps {
  className?: string
  caption: string | React.ReactNode
  color?: string
}

const UserTag = (props: IProps) => (
  <StyledUserTag className={props.className} color={props.color}>
    {props.caption}
  </StyledUserTag>
)

export const StyledUserTag = styled.strong<{ color?: string }>`
  ${tagBaseStyle}
  background-color: ${({ theme, color }) =>
    color ? color : theme.colors.primary};
  color: ${({ theme }) => theme.colors.lightest};
  font-weight: normal;
`

export default UserTag
